import { collectionEngineV1 } from '../apis.js';
const req = collectionEngineV1('/session-events');
export const submitEvents = (data) => req('POST', `/`, {
    body: data,
});
//# sourceMappingURL=session-events.js.map